import PropTypes from 'prop-types';
import React from 'react';
import { Breadcrumb } from 'react-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectCurrentUserActiveEmployerProject } from 'store/resources/selectors/resources.selectors';
import ProjectCrumbRoute from './projectCrumbRoute';
import { useChangeLog, useMountLog } from 'utils/mountLog';

function CrumbRoute(props) {
  const {
    component: Component,
    includeSearch,
    render,
    componentProps,
    ...restProps
  } = props;

  // Diagnostics for the vanishing-photo hunt. The Route below carries a manual
  // `key`, so if that key changes React rebuilds the whole routed scene while
  // this component itself looks untouched — invisible to a mount log, and the
  // exact shape of the failure being chased. Only the CrumbRoute that actually
  // renders a scene is logged; the ~40 breadcrumb-only ones would drown it.
  const routeKey = props.computedMatch?.url;
  useMountLog(Component ? `CrumbRoute ${restProps.path}` : null);
  useChangeLog(Component ? `key ${restProps.path}` : null, routeKey);

  const { t } = useTranslation('common');

  const selectedProject = useSelector(selectSelectedProject);

  const projectName = selectedProject.id
    ? `${selectedProject.name} - ${selectedProject.projectKey}`
    : t('navigation.projects');

  const title = props.title ? props.title : projectName;

  const activeEmployer = useSelector(selectCurrentUserActiveEmployerProject);

  // HIDE MYLIXANI FROM BREAD CRUMBS
  if (title === 'MyLixani' && activeEmployer) {
    return null;
  }

  return (
    <>
      {props.crumbpath && selectedProject.id !== activeEmployer?.id ? (
        <ProjectCrumbRoute></ProjectCrumbRoute>
      ) : null}
      <Route
        {...restProps}
        key={routeKey}
        render={(routeProps) => (
          <>
            <Breadcrumb
              data={{
                title: title,
                pathname: routeProps.match.url,
                search: includeSearch ? routeProps.location.search : null,
                state: {
                  historyProject: routeProps?.location?.pathname || null,
                },
              }}
            >
              {Component ? (
                <Component {...routeProps} {...componentProps} />
              ) : render ? (
                render(routeProps)
              ) : null}
            </Breadcrumb>
          </>
        )}
      />
    </>
  );
}

CrumbRoute.defaultProps = {
  includeSearch: false,
};

CrumbRoute.propTypes = {
  component: PropTypes.any,
  includeSearch: PropTypes.bool,
  render: PropTypes.func,
  title: PropTypes.string,
  parent: PropTypes.string,
  parentKey: PropTypes.string,
};

export default CrumbRoute;
